import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article15() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article16');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article14');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article15-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article15-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <h1 className="fs-xl f-lora mb-2 text-purple">Meet the Makar <br/>Kathleen Jamie</h1>
              <h2 className="f-lora-i mb-4 mb-sm-5 text-purple">A conversation with Scotland’s national poet </h2>
              <p className="f-lora-i lh-base mb-4 mb-sm-5 text-purple" variants={textAnimate}>Scotland has a long and rich tradition with the written word. Meet Kathleen Jamie, who continues it today as the country’s national poet.</p>
              
              <p className="mb-4 mb-sm-5" variants={textAnimate}>Every three years, Scotland appoints a Makar, or national poet. It’s currently Kathleen Jamie, an award-winning writer of poetry and non-fiction raised near Edinburgh. Kathleen’s words are inscribed on the national monument at Bannockburn and have also appeared further afield on the subway systems of New York, London and Shanghai. We spoke to Kathleen about the remarkable role of the national poet, creating in and about Scotland, and what an ‘authentic’ travel experience might mean today. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>Being the national poet of Scotland, or Makar, is a unique role. Could you explain to our readers what it involves? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>The old Scots word ‘makar’ literally means ‘maker’, but it applies mostly to the maker of verses. The idea of the modern Makar or National Poet – I am the fourth to hold the post – is to keep poetry at the heart of national life, to provide poems for public or state occasions, and to encourage public participation in the reading and writing of poetry. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>What has being the Makar meant to you, particularly in a country where poetry has such historic importance? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>It does have historic importance in Scotland – and everywhere. Scotland has poetry in three historic languages. It has people’s poetry – its great internationally known poet [Robert Burns] was a commoner, a ploughman. These things are hugely important to our culture. To be part of that tradition, and to be able to extend it, has been a huge honour of course, and actually a surprising amount of fun. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>What are your hopes and plans for the coming year, your final as Makar? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>My three-year post is flying by. I work through the Scottish Poetry Library and we are planning a tour of public libraries in Scotland throughout my final year. Each visit will take on its own character, with plenty of local input. </p>

              <p className="mb-4 mb-sm-5 text-purple" variants={textAnimate}>Kathleen’s writing crosses boundaries: travel, nature, personal, archaeological, political. Her words come together in poetry collections and non-fiction books published over 30 years, such as ‘Surfacing’, essays which take us from Orkney to Alaska. But Kathleen’s words also give voice to the layers of influence closer to home that make up a life rooted in Scotland. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>You once said that “poetry is about memory”. Could you tell us more about your use of the Scots language in your work? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>I do use Scots, but only recently have I had the time and space to really concentrate on it. For the last couple of years, I’ve been trying to develop my own Scots into a language I use to properly write poetry. To do that, I’ve had to reach back into my own memory, of the way my grandmother’s generation spoke, and my school days – as well as dictionaries, poems, songs. But we’re getting there. All being well, I should have a book of poems in Scots out next year. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>The outdoors is a huge influence for you. Is there a specific place in Scotland you go to find creative inspiration? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>That would be telling! I often think when walking, and I relish the rare chance to just sit and observe. A whole day spent seawatching would be a treat. You never know what might happen. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>What is your writing practice like and what part does where you live play in it? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>My writing practice is fugitive. I don’t have a book-lined study. I flit around the house, and I don’t have much of a routine. This used to frustrate me but I’ve come to think it’s maybe necessary – writing in stolen moments. I think my breakthrough came when I realised that life is also the domestic, work-mother life stuff. It’s also nature, and part of art, not separate from it. </p>

              <p className="mb-4 mb-sm-5 text-purple" variants={textAnimate}>In 2020, Kathleen worked with writers and artists across Scotland to curate a new collection of Scottish nature writing. It’s called Antlers of Water, the title taken from the final lines of a Norman MacCaig poem about the landscapes of Sutherland. Bringing together essays, photography and poetry, the collection examines how we think about the environment of Scotland and opens up interesting questions for both locals and visitors. </p>

              <h1 className="f-lora-i mb-4 mb-sm-5 text-purple">“The idea of the modern Makar or National Poet is to keep poetry at the heart of national life…”</h1>

              <p className="mb-3 text-gold" variants={textAnimate}>In the Antlers of Water nature writing anthology you say that “the ‘wild’ is actually hard to find” in Scotland. What does ‘wild’ mean to you? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>I really don’t know. Human interventions are everywhere – even a place that looks ‘wild’ has chemical pollutants and microplastics. But it means we have to get real. Climate disruption and the biodiversity crisis is real and happening – even in Scotland – and we can’t pretend otherwise. We have to get to grips with it. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>How do you cultivate deeper relationships with the places you visit or pass through? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>I think the key phrase here is ‘passing through’. Relationships take time – with landscapes, with people. </p>

              <p className="mb-3 text-gold" variants={textAnimate}>How would you recommend that people immerse themselves in the ‘real’ Scotland, if such a thing exists? </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>I’ve no idea what ‘real Scotland’ is… An Old Firm match? Portobello beach? The top of Schiehallion? The queue for a CalMac ferry? Real is where you make it, I guess. </p>

              <p className="mb-4 mb-sm-5 text-purple" variants={textAnimate}>To discover more of Kathleen Jamie’s work, and that of other poets based in Scotland and beyond, visit the Scottish Poetry Library. Located in Edinburgh’s Old Town, just off the Canongate and in the shadow of the Scottish Parliament, the Poetry Library holds inspiring events and exhibitions on a regular basis. Go to scottishpoetrylibrary. org.uk for more and follow @KathleenJamie on Twitter to see what the Makar does next. </p>
            </div>

          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article15;
